import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Third party
import { Ng2FileInputModule } from 'ng2-file-input';

// Local modules
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';

// Local components
import { DocumentsComponent } from './documents.component';
import { SeriesDocumentaryComponent } from './series-documentary/series-documentary.component';
import { SubSeriesDocumentaryComponent } from './subseries-documentary/subseries-documentary.component';
import { TypeDocumentaryComponent } from './type-documentary/type-documentary.component';
import { DocumentClassificationComponent } from './document-classification/document-classification.component';

@NgModule({
  imports: [
    CommonModule,
    SharedAdministrationModule,
    Ng2FileInputModule
  ],
  declarations: [
    DocumentsComponent,
    SeriesDocumentaryComponent,
    SubSeriesDocumentaryComponent,
    TypeDocumentaryComponent,
    DocumentClassificationComponent
  ]
})
export class DocumentsModule { }



// WEBPACK FOOTER //
// ./src/app/administration/documents/documents.module.ts